import styled from 'styled-components';
import { COLORS, FLEX_CONTAINER } from 'utils/styles';
import { Images } from 'assets/images';
import { deviceMax } from 'utils/styles/breakpoints';

export const SuggestionFullWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  padding-top: 50px;
  padding-bottom: 50px;
  margin-top: 50px;
  background-image: url(${Images.settingsBackgroundOrigin});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: calc(100vh - 232px);
  box-shadow: 0 4px 24px -1px ${COLORS.mainColor};
`;

export const SuggestionContent = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: 1200px;
  backdrop-filter: blur(20px);
  border-radius: 12px;
  height: ${({ isSuggestion }) => (isSuggestion ? '600px' : 'auto')};
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );

  @media only screen and ${deviceMax.laptopL} {
    width: 688px;
  }

  @media only screen and ${deviceMax.tablet} {
    width: 408px;
    padding-bottom: 50px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 302px;
  }
`;

export const SuggestionImage = styled.img`
  object-fit: cover;
  border-radius: 8px;
  height: 300px;
  width: 100%;
  display: flex;
  align-self: flex-start;
  justify-self: flex-start;
`;

export const BackArrow = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  padding-left: 30px;
  width: 100%;
  height: 40px;
  padding-top: 20px;
  margin-bottom: 20px;
`;

export const BackArrowImg = styled.img`
  cursor: pointer;
`;
